import { onMounted, onUnmounted } from 'vue'

export function useEventListener(
  target: EventTarget,
  event: string,
  callback: EventListenerOrEventListenerObject,
  isInstantCall = false
) {
  onMounted(() => {
    target.addEventListener(event, callback)
    if (isInstantCall) {
      ;(callback as () => void)()
    }
  })
  onUnmounted(() => target.removeEventListener(event, callback))
}
